import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/company-select/company-select').then((m) => m.CompanySelect),
  },
  {
    path: 'dashboard/:companyId',
    loadComponent: () =>
      import('./pages/leads-dashboard/leads-dashboard').then((m) => m.LeadsDashboard),
  },
  { path: '**', redirectTo: '' },
];